module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.config.theme
  }, [_c('vue-drr', {
    staticClass: "scoreboard",
    attrs: {
      "w": 180,
      "h": 180,
      "r": 0,
      "resizeable": false,
      "rotatable": false
    }
  }, [_c('h3', [_vm._v("计分板")]), _vm._v("\n    旗帜数量： " + _vm._s(_vm.flagCount) + " "), _c('br'), _c('br'), _vm._v("\n    分数： " + _vm._s(_vm.score) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "game-config"
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.init($event)
      }
    }
  }, [_c('label', [_vm._v("行: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputRow),
      expression: "inputRow"
    }],
    attrs: {
      "type": "number",
      "min": "2",
      "max": _vm.config.maxRow
    },
    domProps: {
      "value": (_vm.inputRow)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputRow = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("列: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputCol),
      expression: "inputCol"
    }],
    attrs: {
      "type": "number",
      "min": "2",
      "max": _vm.config.maxCol
    },
    domProps: {
      "value": (_vm.inputCol)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputCol = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("雷的数量: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputBombCount),
      expression: "inputBombCount"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "max": ~~_vm.inputRow * ~~_vm.inputCol - 1
    },
    domProps: {
      "value": (_vm.inputBombCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputBombCount = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("生成")])]), _vm._v(" "), (_vm.showTips) ? _c('div', {
    staticClass: "game-config-tips"
  }, [_vm._v(_vm._s(_vm.tipsText))]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "game",
    class: {
      'tips-open': _vm.showTips
    },
    attrs: {
      "width": _vm.width
    },
    on: {
      "click": _vm.handleClick,
      "contextmenu": function($event) {
        $event.preventDefault();
        _vm.handleRightClick($event)
      },
      "dblclick": _vm.handleDblClick
    }
  }, _vm._l((_vm.cellData), function(rows, row) {
    return _c('tr', {
      key: row
    }, _vm._l((rows), function(cell, col) {
      return _c('cell', {
        key: col,
        attrs: {
          "row": cell.row,
          "col": cell.col,
          "isBomb": cell.isBomb,
          "status": cell.status,
          "isFlag": cell.isFlag,
          "bombCount": cell.bombCount
        }
      })
    }))
  })), _vm._v(" "), (_vm.gameOver) ? _c('div', {
    staticClass: "gameover layer"
  }, [_c('div', [_vm._v("Game Over")]), _vm._v(" "), _c('div', [_vm._v("你美丽了!")]), _vm._v(" "), _c('div', {
    staticClass: "retry"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.init($event)
      }
    }
  }, [_vm._v("再试一次")])]), _vm._v(" "), _c('div', {
    staticClass: "retry"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.view($event)
      }
    }
  }, [_vm._v("查看雷的位置")])])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "success layer"
  }, [_c('div', [_vm._v("Win!")]), _vm._v(" "), _c('div', [_vm._v("你成功了!")]), _vm._v(" "), _c('div', {
    staticClass: "retry"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.init($event)
      }
    }
  }, [_vm._v("我还要玩")])])]) : _vm._e(), _vm._v(" "), (_vm.viewBomb) ? _c('div', {
    staticClass: "layer-transparent"
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-75f32dd9"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/game.vue
// module id = 45
// module chunks = 1